var base = require('settings/subscription/update-subscription');

Vue.component('spark-update-subscription', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/subscription/update-subscription.js